<app-spinner *ngIf="isLoading" [type]="'normal'"></app-spinner>
<div class="container-fluid p-0 m-0">
  <!-- <div class="heightfull"> -->

  <!-- <div class="logoclass col-md-12 row">
            <img class="logoimg mt-3" src="../../../../assets/images/image(2).png">
        </div> -->
  <div class="contentbox w-100 h-100" *ngIf="isLogin == true">
    <!-- <div class="content"> -->
    <div class="row p-0 m-0">
      <div class="leftimg col-md-8 p-0 align-self-center d-none d-sm-block">
        <img
          class="leftimg"
          src="../../../../assets/images/wetap_newlogin.png"
        />
      </div>
      <div class="col-md-4 p-0 d-grid align-self-center rightDiv">
        <div class="form_outer">
          <div class="inner_form">
            <div class="text-center pb-4">
              <img
                src="../../../../assets/images/wetapwelcome_logo.svg"
                style="height: 40px"
              />
            </div>
            <div class="formcontent text-center pt-4 pb-4">
              <!-- <p class="welcome">Welcome</p> -->
              <span>
                <p class="log-in" #login>Admin Log In</p>
                <!-- <span class="line"></span> -->
              </span>
            </div>
            <div class="inputs">
              <form [formGroup]="loginForm">
                <div class="form-group mt-4 mb-4">
                  <label>Email</label>
                  <input
                    type="text"
                    formControlName="email"
                    class="form-control login_input"
                    id="exampleInputEmail1"
                    placeholder="Enter Email Address"
                  />
                  <div
                    *ngIf="
                      loginForm.controls['email'].invalid &&
                      (loginForm.controls['email'].dirty ||
                        loginForm.controls['email'].touched)
                    "
                    class="errorinput text-left"
                  >
                    <div *ngIf="loginForm.controls['email'].errors.required">
                      *Email is required.
                    </div>
                    <div *ngIf="loginForm.controls['email'].errors.pattern">
                      *Invalid email .
                    </div>
                  </div>
                </div>

                <div class="form-group mt-4 mb-4 position-relative">
                  <label>Password</label>
                  <input
                    type="password"
                    formControlName="password"
                    [type]="show ? 'text' : 'password'"
                    class="form-control login_input"
                    id="exampleInputEmail1"
                    placeholder="Enter Password"
                  />
                  <img
                    *ngIf="show == false"
                    (click)="password()"
                    class="show_password"
                    src="../../../../assets/images/visibility.png"
                    alt=""
                  />
                  <img
                    *ngIf="show == true"
                    (click)="password()"
                    class="show_password"
                    src="../../../../assets/images/view.png"
                    alt=""
                  />
                  <div
                    *ngIf="
                      loginForm.controls['password'].invalid &&
                      (loginForm.controls['password'].dirty ||
                        loginForm.controls['password'].touched)
                    "
                    class="errorinput text-left"
                  >
                    <div *ngIf="loginForm.controls['password'].errors.required">
                      *Password is required.
                    </div>
                    <div
                      *ngIf="loginForm.controls['password'].errors.minlength"
                    >
                      *Minimum password length is 6.
                    </div>
                  </div>
                </div>
                <p class="forgot _add_cursor" (click)="navigateForgot('false')">
                  Forgot Password?
                </p>
                <div class="pt-3 pb-3 d-flex justify-content-center">
                  <button
                    class="btn LoginBtn"
                    [disabled]="!loginForm.valid"
                    (click)="loginFunct()"
                  >
                    LOG IN
                  </button>
                </div>

                <!-- <p class="text-center">v2.1</p> -->
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </div>
  <div *ngIf="isLogin == false">
    <div class="content w-100">
      <div class="row p-0 m-0">
        <app-spinner *ngIf="isLoading" [type]="'normal'"></app-spinner>
        <div class="leftimg col-md-8 p-0 align-self-center d-none d-sm-block">
          <img
            class="leftimg"
            src="../../../../assets/images/wetap_login.png"
          />
        </div>
        <div class="col-md-4 p-0 d-grid align-self-center rightDiv">
          <div class="form_outer">
            <div class="text-center pb-4">
              <img
                src="../../../../assets/images/wetapwelcome_logo.svg"
                style="height: 40px"
              />
            </div>
            <div class="inner_form pt-4">
              <div class="formcontent text-center">
                <p class="log-in">Forgot Password?</p>
                <p>
                  Enter registered email address.<br />
                  We’ll send you an email to reset your password.
                </p>
              </div>
              <div class="inputs pt-3">
                <form [formGroup]="resetForm">
                  <div class="form-group mt-3 mb-1">
                    <label>Email</label>
                    <input
                      type="text"
                      formControlName="email"
                      class="form-control login_input"
                      id="exampleInputEmail1"
                      placeholder="Email"
                    />
                    <div
                      *ngIf="
                        resetForm.controls['email'].invalid &&
                        (resetForm.controls['email'].dirty ||
                          resetForm.controls['email'].touched)
                      "
                      class="errorinput text-left"
                    >
                      <div *ngIf="resetForm.controls['email'].errors.required">
                        *Email is required.
                      </div>
                      <div *ngIf="resetForm.controls['email'].errors.pattern">
                        *Invalid email .
                      </div>
                    </div>
                  </div>

                  <div class="pt-4 d-flex justify-content-center">
                    <button
                      class="btn LoginBtn"
                      [disabled]="!resetForm.valid"
                      (click)="resetSubmit()"
                    >
                      SUBMIT
                    </button>
                  </div>
                  <p
                    class="forgot _add_cursor mt-4"
                    (click)="navigateForgot('true')"
                  >
                    Back to Log In ?
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</div>
